import { get, post } from '@/helpers/api'
import { getEnv } from '@/helperMethods'
import Invite from './Invite'
import GetStarted from './GetStarted'
import JoinForm from './JoinForm'
import Signin from './Signin'
import EmailPhoneForm from './EmailPhoneForm'
import Verification from './Verification'
import MobileDownload from './MobileDownload'
import InviteAccounts from './InviteAccounts'
import InviteActiveAccounts from './InviteActiveAccounts'
import InviteCode from './InviteCode'
import InviteFull from './InviteFull'
import parsePhoneNumberFromString from 'libphonenumber-js'
import { storage } from '@/helpers/utils'

export { Invite as default }

export const INVITE_REGEX_PROD = /https?:\/\/app\.pronto\.io\/invites\/(\w+)/gi
export const INVITE_REGEX_DEV = /https?:\/\/app\.dev\.pronto\.io\/invites\/(\w+)/gi

export const getInviteRegex = () => {
	return ['local', 'dev'].includes(getEnv())
		? INVITE_REGEX_DEV
		: INVITE_REGEX_PROD
}

export const checkForInviteLink = (urlStr) => {
	return urlStr.match(getInviteRegex())
}

export const getInviteCodeFromUrl = (urlStr) => {
	if (!urlStr) return urlStr
	if (!checkForInviteLink(urlStr)) return null
	try {
		const url = new URL(urlStr)
		return url.pathname.split('/').pop()
	} catch (e) {
		return null
	}
}

// valid external invite code: s56K9p4Yg
// valid internal invite code: NTQ57F
let inviteData = {}
let userData = {}

const inviteCache = storage.get(`pronto_invite`)
if (inviteCache) {
	try {
		const cache = JSON.parse(inviteCache)
		Object.assign(inviteData, inviteCache)
	} catch (e) {}
}

const userCache = storage.get('pronto_invite_user')
if (userCache) {
	try {
		Object.assign(userData, userCache)
	} catch (e) {}
}

export const fetchInviteMeta = async (code) => {
	if (!code) return
	code = encodeURIComponent(code)
	const { data } = await get(`/api/clients/invites/${code}/meta`)
	return setInviteData({ ...data.data, code })
}

export const getInvite = () => {
	return inviteData
}

window.getInvite = getInvite

export const setInviteData = (data) => {
	if (!data) return null
	if (data.organization) {
		data.organization.profilepic = !!data.organization.profilepicurl
	}
	if (inviteData?.code !== data.code) {
		clearInviteData()
	}
	Object.assign(inviteData, data)
	localStorage.setItem('pronto_invite', JSON.stringify(inviteData))
	return inviteData
}

export const clearInviteData = () => {
	localStorage.removeItem('pronto_invite')
	inviteData = {}
}

export const getUserData = () => {
	return userData
}

export const setUserData = (data) => {
	if (!data) return null
	Object.assign(userData, data)
	localStorage.setItem('pronto_invite_user', JSON.stringify(userData))
	return userData
}

export const clearUserData = () => {
	localStorage.removeItem('pronto_invite_user')
	userData = {}
}

export const verifyUser = async ({
	firstname,
	lastname,
	phone,
	email,
	code,
}) => {
	const body = { firstname, lastname }
	if (phone) {
		body.phone = phone
	} else {
		body.email = email
	}

	if (!body.phone && !body.email) return

	const { data } = await post(
		`/api/clients/invites/${code}/verificationcode`,
		body
	)

	return { ...body, expires: data.expires }
}

export const sendCodeToExistingUser = async (body) => {
	if (body.phone) {
		const { number, country } = parsePhoneNumberFromString(body.phone)
		body = { phone: number, phone_country: country }
	}
	const invite = getInvite()
	body.organization_id = invite.organization.id
	const { data } = await post(
		`/api/v1/user.verify?organization_id=${body.organization_id}`,
		body
	)
	return data
}

export const sendCodeToNewUser = async (body) => {
	const { code } = getInvite()
	const { firstname, lastname } = getUserData()
	const { data } = await post(`/api/clients/invites/${code}/verificationcode`, {
		firstname,
		lastname,
		...body,
	})
	return data
}

export const getStartedRoute = {
	path: 'start',
	name: 'getStarted',
	component: GetStarted,
}

export const signinRoute = {
	path: 'signin',
	name: 'signin',
	component: Signin,
}

export const emailRoute = {
	path: 'email',
	name: 'signinemail',
	component: EmailPhoneForm,
}

export const phoneRoute = {
	path: 'phone',
	name: 'signinphone',
	component: EmailPhoneForm,
}

export const joinFormRoute = {
	path: 'joinForm',
	name: 'joinForm',
	component: JoinForm,
}

export const verificationRoute = {
	path: 'verification',
	name: 'verification',
	component: Verification,
}

export const newAccountsRoute = {
	path: 'accounts',
	name: 'newAccounts',
	component: InviteAccounts,
}

export const codeRoute = {
	path: 'code',
	name: 'code',
	component: InviteCode,
}

export const groupFullRoute = {
	path: 'full',
	name: 'groupFull',
	component: InviteFull,
}

export const activeAccountsRoute = {
	path: 'active-accounts',
	name: 'activeAccounts',
	component: InviteActiveAccounts,
}

export const mobileDownloadRoute = {
	path: 'mobile',
	name: 'mobileDownload',
	component: MobileDownload,
}

export const inviteRoute = {
	path: '/invites/:code?',
	name: 'invite',
	component: Invite,

	children: [
		getStartedRoute,
		signinRoute,
		emailRoute,
		phoneRoute,
		joinFormRoute,
		verificationRoute,
		newAccountsRoute,
		codeRoute,
		groupFullRoute,
		activeAccountsRoute,
		mobileDownloadRoute,
	],
}
